var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoPoverty = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Monetization-Team--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Monetization Team Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4 21a3 3 0 0 0 -3 3h6a3 3 0 0 0 -3 -3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 24h6a3 3 0 0 0 -6 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 24h6a3 3 0 0 0 -6 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5a2 2 0 1 0 4 0 2 2 0 1 0 -4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18.5a2 2 0 1 0 4 0 2 2 0 1 0 -4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18.5a2 2 0 1 0 4 0 2 2 0 1 0 -4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.33 7.5H10a1 1 0 0 0 0 2h0.75a0.25 0.25 0 0 1 0.25 0.25V10a1 1 0 0 0 2 0v-0.26a0.25 0.25 0 0 1 0.23 -0.25A1.83 1.83 0 0 0 15 7.5c0 -1.19 -1.19 -2 -2.44 -2.83 -0.3 -0.2 -0.71 -0.48 -1 -0.72a0.25 0.25 0 0 1 -0.09 -0.28 0.26 0.26 0 0 1 0.24 -0.17H14a1 1 0 0 0 0 -2h-0.75a0.25 0.25 0 0 1 -0.25 -0.25V1a1 1 0 0 0 -2 0v0.26a0.25 0.25 0 0 1 -0.23 0.25A1.8 1.8 0 0 0 9 3.5c0 1.19 1.19 2 2.44 2.83 0.3 0.2 0.71 0.48 1 0.72a0.25 0.25 0 0 1 0.09 0.28 0.26 0.26 0 0 1 -0.2 0.17Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5a1 1 0 0 0 1 -1v-0.25a0.25 0.25 0 0 1 0.25 -0.25h5.5a0.25 0.25 0 0 1 0.25 0.25v0.25a1 1 0 0 0 2 0v-0.25a0.25 0.25 0 0 1 0.25 -0.25h5.5a0.25 0.25 0 0 1 0.25 0.25v0.25a1 1 0 0 0 2 0V13a1 1 0 0 0 -1 -1H4a1 1 0 0 0 -1 1v1.5a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoPoverty);
export default ForwardRef;